var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"db f6 br-pill ph3 ba bw1 pv2 dib ma1",class:{
    'b--purple purple': _vm.brand === 'lh',
    'b--dark-gray dark-gray': _vm.brand === 'lq'
  },on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"flex items-center"},[(_vm.icon)?_c('simple-svg',{staticClass:"dib mr2",class:{
        'purple': _vm.brand === 'lh',
        'dark-gray': _vm.brand === 'lq'
      },staticStyle:{"width":"1.5rem","height":"1.5rem"},attrs:{"filepath":_vm.icon}}):_vm._e(),(_vm.text)?_c('div',{staticClass:"dib b",domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }